import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import SignUpScreen from '../screens/SignUpScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('signup')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SignUpScreen />
    </StrictMode>,
  )
}

bootstrap()
